import {Form} from 'antd';
import styles from './FilterFormItem.module.scss';

export const FilterFormItem = ({labelAlign = 'left', colon = false, ...props}) => {
  const {children} = props;

  return (
    <Form.Item className={styles.formItem} labelAlign={labelAlign} colon={colon} {...props}>
      {children}
    </Form.Item>
  );
};
